import React from 'react'
import {
  List as MedkitList,
  ListItem as MedkitListItem,
  Icon,
  Text,
} from '@babylon/medkit'
import { BulletList, BulletListItem } from '@babylon/web-platform-ui'
import { ProductFeature } from '@/types/partnerConfig'

import styles from './ProductFeatures.module.scss'
import { useConfig } from '@/redux/partnerConfig/selectors'

interface Props {
  features?: ProductFeature[]
}

const ProductFeatures = ({ features = [] }: Props) => {
  const { useDnaV2Design } = useConfig()

  if (useDnaV2Design) {
    return (
      <BulletList as="ul" marginBottom={9}>
        {features.map(({ title, description }) => (
          <BulletListItem key={title}>
            <div className={styles.ProductFeaturesContent}>
              {title}
              {description}
            </div>
          </BulletListItem>
        ))}
      </BulletList>
    )
  }

  return (
    <MedkitList variant="ul" className={styles.ProductFeaturesList}>
      {features.map(({ icon, title, description }, index) => (
        <MedkitListItem key={title} className={styles.ProductFeaturesListItem}>
          <Icon
            className={styles.ProductFeaturesIcon}
            icon={icon}
            title={title}
          />
          <div className={styles.ProductFeaturesContent}>
            {title && (
              <Text
                variant={title && description ? 'h5' : 'body'}
                data-testid={`productFeatureTitle-${index}`}
              >
                {title}
              </Text>
            )}
            {description && (
              <Text
                variant="body"
                data-testid={`productFeatureDescription-${index}`}
              >
                {description}
              </Text>
            )}
          </div>
        </MedkitListItem>
      ))}
    </MedkitList>
  )
}

export default ProductFeatures
